import React from "react";
import PropTypes from "prop-types";
// Material imports
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import AnnouncementContent from "../../announcement-content/AnnouncementContent";
const AnnouncementDialog = ({
  classes,
  announcements,
  onAnnouncementDismiss,
  remoteContentComponent,
  onSaveAnnouncement,
  isCrowdManager = false
}) => {
  const announcement = announcements[0];
  return /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    "aria-labelledby": "announcementSummary",
    "aria-describedby": "alert-dialog-announcement",
    onClose: (event, reason) => reason === "backdropClick" ? false : reason === "escapeKeyDown" ? false : null,
    classes: {
      paper: classes.dialogRoot
    },
    maxWidth: "md",
    disablePortal: false,
    scroll: "paper"
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "announcementSummary",
    className: classes.dialogTitle
  }, announcement.summary), /*#__PURE__*/React.createElement(DialogContent, {
    className: classes.dialogContent
  }, /*#__PURE__*/React.createElement(AnnouncementContent, {
    onSave: () => onSaveAnnouncement ? onSaveAnnouncement(announcement) : {},
    onDismiss: onAnnouncementDismiss,
    announcement: announcement,
    remoteContentComponent: remoteContentComponent,
    isCrowdManager: isCrowdManager
  })));
};
const styles = {
  dialogTitle: {
    paddingBottom: 0,
    paddingTop: 18,
    paddingLeft: 20
  },
  dialogContent: {
    padding: 0
  },
  dialogPaper: {
    width: "60%"
  }
};
export default withStyles(styles)(AnnouncementDialog);
AnnouncementDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  announcements: PropTypes.array.isRequired,
  onAnnouncementDismiss: PropTypes.func.isRequired,
  onSaveAnnouncement: PropTypes.func,
  remoteContentComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.object]).isRequired,
  isCrowdManager: PropTypes.bool
};